export enum AutoProductCategories {
  NEW = 'new',
  USED = 'used'
}

export enum ManufacturingOrigin {
  IMPORTED = 'imported',
  DOMESTIC = 'domestic'
}
